import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { UserData, UserLevel } from '@e3dc-react/shell/Types'
import { stringSchema } from 'src/Configuration/validation/rules'
import { FormInitializerReturnType } from 'src/Configuration/validation'
import { ContactData } from 'src/Libs/user/models'
import { AccountProfileForm } from 'src/Libs/user/types'
import { boolean, number, object, string } from 'yup'

const MIN_EMAIL_LENGTH = 5
const MAX_EMAIL_LENGTH = 100
const MIN_NAME_LENGTH = 2
const MIN_DEFAULT_LENGTH = 3
const MAX_DEFAULT_LENGTH = 50
const MAX_ZIP_LENGTH = 10
const MAX_PHONE_LENGTH = 30

/**
 *  Initializes the form for editing user profile settings
 * @param user UserData
 * @param userContact ContactData
 * @returns initialValues and validationSchema for user profile form
 */
export const useUserProfileSettingsFormInitializer = (
  user: UserData,
  userContact?: ContactData
): FormInitializerReturnType<AccountProfileForm, AccountProfileForm> => {
  const { t } = useCustomTranslation()
  const stringSchemaWithTranslation = stringSchema(t)
  const initialValues = {
    username: user.username,
    eMail: userContact?.Email ?? '',
    firstName: user.Vorname ?? '',
    lastName: user.Name ?? '',
    city: userContact?.Address ?? '',
    zipCode: userContact?.PLZ ?? '',
    address: userContact?.PlaceOR ?? '',
    country: userContact?.Land ?? '',
    phoneNumber: userContact?.Telefon ?? '',
    eMailNotification: user.mailNotification ?? false,
  }

  const validationSchema = object().shape({
    username: string().required(),
    eMail: stringSchemaWithTranslation({ minLength: MIN_EMAIL_LENGTH, maxLength: MAX_EMAIL_LENGTH }).email().required().trim(),
    firstName: stringSchemaWithTranslation({ minLength: MIN_NAME_LENGTH, maxLength: MAX_DEFAULT_LENGTH }).required().trim(),
    lastName: stringSchemaWithTranslation({ minLength: MIN_NAME_LENGTH, maxLength: MAX_DEFAULT_LENGTH }).required().trim(),
    address: stringSchemaWithTranslation({ minLength: MIN_DEFAULT_LENGTH, maxLength: MAX_DEFAULT_LENGTH }).trim(),
    zipCode: stringSchemaWithTranslation({ minLength: MIN_DEFAULT_LENGTH, maxLength: MAX_ZIP_LENGTH }).trim(),
    city: stringSchemaWithTranslation({ minLength: MIN_DEFAULT_LENGTH, maxLength: MAX_DEFAULT_LENGTH }).trim(),
    country: string().default(''),
    phoneNumber: stringSchemaWithTranslation({ minLength: MIN_DEFAULT_LENGTH, maxLength: MAX_PHONE_LENGTH })
      .transform(value => (value === '' ? null : value))
      .trim(),
    eMailNotification: boolean().required(),
    latitude: number(),
    longitude: number(),
    level: string<UserLevel>(),
  })
  return { initialValues, validationSchema }
}
